import { render } from "./LabelDialog.vue?vue&type=template&id=42b3e7b6&scoped=true"
import script from "./LabelDialog.vue?vue&type=script&lang=js"
export * from "./LabelDialog.vue?vue&type=script&lang=js"

import "./LabelDialog.vue?vue&type=style&index=0&id=42b3e7b6&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b3e7b6"]])

export default __exports__